import styled from 'styled-components'

import MenuEntryLink from '../MenuEntryLink'
import { megaMenuLinkStyles } from '../styles/desktop-menu'

export const MegaMenuList = styled.ul`
  list-style: none;
  padding-left: 0;
`

export const MegaMenuListEntry = styled.li`
  margin-bottom: 0.5rem;
`

export const MegaMenuSeeAllLink = styled(MenuEntryLink)`
  ${megaMenuLinkStyles};
  color: ${({ theme }) => theme.colors.brand.red};
  &:focus {
    outline: 1px solid ${({ theme }) => theme.colors.brand.red};
  }
  font-weight: 700;
`
